import { render, staticRenderFns } from "./bankDc.vue?vue&type=template&id=105d9645&scoped=true"
import script from "./bankDc.vue?vue&type=script&lang=js"
export * from "./bankDc.vue?vue&type=script&lang=js"
import style0 from "./bankDc.vue?vue&type=style&index=0&id=105d9645&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105d9645",
  null
  
)

export default component.exports